import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import APCard from "../../../components/cards/APCard";
import { toDollars } from "../../../helpers/currencies";
import { formatDate } from "../../../helpers/dates";
import { useApi } from "../../../providers/ApiProvider";
import {
  DossierTransaction,
  DossierTransactionStatus,
  DossierTransactionTypeLabelMap,
} from "../../../types/DossierTransaction";

export const DossierTransactionStatusLabelMap: Record<
  DossierTransactionStatus,
  string
> = {
  unpaid: "Awaiting Payment",
  "payment-in-progress": "Payment in Progress",
  paid: "Paid",
  cancelled: "Cancelled",
};

const DossierTransactionCard = ({
  transaction,
}: {
  transaction: DossierTransaction;
}) => {
  const { fetchFile } = useApi();

  const handleDownload = async (claimId: string, fileName: string) => {
    fetchFile("getExpenseClaimFile", transaction.dossierId, fileName, {
      queryParams: {
        claimId: claimId,
        type: "taxInvoice",
      },
    });
  };

  const renderTitleLeft = () => {
    return (
      <Typography variant="titleMedium">
        {formatDate(transaction.transactionDate)} -{" "}
        {DossierTransactionTypeLabelMap[transaction.type]}
      </Typography>
    );
  };

  const renderBodyContent = () => {
    return (
      <Typography variant="bodyMedium">{transaction.description}</Typography>
    );
  };

  const renderExpandContent = () => {
    return (
      <Box display="flex" flexDirection="column" gap={1}>
        <Typography variant="bodyMedium">
          {DossierTransactionStatusLabelMap[transaction.status]}
        </Typography>
        <Typography variant="bodyMedium">
          Inc GST: {toDollars(transaction.incGst, 2)}
        </Typography>
        {transaction.expenseClaimId &&
          transaction.expenseClaimTaxInvoiceName && (
            <Typography
              variant="bodySmall"
              color="primary"
              onClick={() =>
                handleDownload(
                  transaction.expenseClaimId || "",
                  transaction.expenseClaimTaxInvoiceName || ""
                )
              }
              sx={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {transaction.expenseClaimTaxInvoiceName}
            </Typography>
          )}
      </Box>
    );
  };

  const renderTitleRight = () => {
    return (
      <Typography variant="titleMedium">
        {toDollars(transaction.exGst, 2)}
      </Typography>
    );
  };

  return (
    <APCard
      titleLeft={renderTitleLeft()}
      bodyContent={renderBodyContent()}
      expandContent={renderExpandContent()}
      titleRight={renderTitleRight()}
      color="neutralWhite"
      expandOnTitleClick={true}
    />
  );
};

export default DossierTransactionCard;
